<template>
    <div>
        <b-modal id="bookInfo" :title="'Інформація про книгу ' + book.code" size="size" footer-class="reader-footer" content-class="reader-content">
            <template v-slot:default>
                <div class="row" v-if="book.id">
                    <div class="text-center col-4">
                        <div class="cover book">
                            <div class="book-cover" style="height: 90%; overflow: hidden">
                              <img :src="book.description.scan_book ? '/uploads/'+book.description.scan_book : '/images/cover-default.png'" alt="" style="width: 100%">
                            </div>
                            <div class="m-t-10">
                                ISBN <span v-for="isbn in book.description.isbn">{{ isbn.name }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="col-4" >
                        <h1>{{ book.description.title }}
                          <span style="font-size: 18px" v-if="book.description.type_record && book.description.type_record.id == 2 && book.description.number_name">({{ book.description.number_name }})</span>
                          <span style="font-size: 18px" v-else-if="book.description.type_record && (book.description.type_record.id == 3 || book.description.type_record.id == 4) && book.description.name_parts">({{ book.description.name_parts }})</span>
                          <span style="font-size: 18px" v-if="book.description.publication_name">
                            <br>
                          <br>{{ book.description.publication_name.name }}</span>
                        </h1>
                        <span v-if="book.description.author">{{ book.description.author.name }}</span>
                        <br>
                        <div>
                            <i v-for="n in 3" class="mdi mdi-star star"></i><i class="mdi mdi-star-half star"></i><i class="mdi mdi-star-outline star"></i>
                        </div>
                        <div class="m-t-20">
                            <span class="table-show-reader">Видавництво:</span>
                            <hr style="margin-top: 0">
                            <div class="row">
                                <div class="col-10">
                                    <span style="font-size: 14px" v-if="book.description.publication && book.description.publication.name">{{ book.description.publication.name }}, {{ book.description.year }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="m-t-20">
                            <span class="table-show-reader">Належить до:</span>
                            <hr style="margin-top: 0">
                            <div class="row">
                                <div class="col-11">
                                    <span style="font-size: 14px"><b>{{ book.example.title }}</b> / {{ book.library.title }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-4 text-center">
                        <div class="cover reader-avatar-show" v-if="book.reader">
                            <div class="d-flex p-20 p-b-0" style="cursor: pointer;" @click="getModal">
                                <div class="col-6 text-center p-r-10 d-flex justify-content-center">
                                    <div class="avatar" :style="book.reader.photo ? 'background-image:url(/uploads/'+book.reader.photo+')' : 'background-image:url(/images/avatar.png)'"></div>
                                </div>
                                <div class="col-6 m-auto p-l-0">{{ book.reader.fullname }}</div>
                            </div>
                          <div class="p-l-20 p-b-0">
                            <div class="col-6">
                              <div class="m-t-10">
                                <i v-for="n in 3" class="mdi mdi-star star-reader"></i><i class="mdi mdi-star-half star-reader"></i><i class="mdi mdi-star-outline star-reader"></i>
                              </div>
                            </div>
                          </div>

                            <hr class="m-l-20 m-r-20">
                            <div class="row p-20 p-b-0 p-t-0">
                                <div class="col-6 text-left">
                                    <span>Дата видачі:</span>
                                </div>
                                <div class="col-6 text-right text-nowrap">
                                    <span class="date">{{ moment(book.updated_at).format("YYYY-MM-DD hh:mm:ss") }}</span>
                                </div>
                            </div>
                            <div class="row p-l-20 p-r-20">
                                <div class="col-6 text-left">
                                    <span>Повернути до:</span>
                                </div>
                                <div class="col-6 text-right">
                                    <span class="date">{{ book.back_date }}</span>
                                </div>
                            </div>
                            <div class="row p-l-20 p-r-20">
                                <div class="col-12">
                                    <div class="btn btn-debtor m-t-20 m-b-20" v-if="book.reader.debtor_days">Заборгованість {{ book.reader.debtor_days }}
                                        днів</div>
                                    <div class="btn btn-debtor not-debtor m-t-20 m-b-20" v-else>Немає заборгованості</div>
                                </div>
                            </div>
                        </div>
                      <div v-else class="cover reader-avatar-show">

                      </div>
                    </div>
                </div>
                <div class="row" v-else>
                    <p>Нічого не знайдено</p>
                </div>
            </template>

            <template v-slot:modal-footer>
                <div class="row w-100 m-b-30 text-center" v-if="book.hasOwnProperty('id')">
                    <div class="col-4">
                        <a :href="'/library/description/' + book.description_id" class="btn btn-outline-secondary m-auto" style="padding:18px">
                            Детальніше...
                        </a>
                    </div>
                    <div class="col-4" v-if="book.status_id == 1">

                        <table style="display:none">
                            <td :id="'book' + book.id" style="text-align: center;" class="book-print" :data-bookid="book.id" :data-title="book.description.title">
                                <img class="barcode" jsbarcode-format="CODE39" :jsbarcode-value="book.code"/>
                                <br>
                                <span style="font-size: 8px; color: #a7afba;">{{ book.code }}</span>
                            </td>
                        </table>

                        <a v-if="book.search_by_invent" @click="$parent.printBarcode('#book' + book.id, true)" class="btn btn-outline-primary m-auto" style="padding:18px">
                            Друкувати штрих код
                        </a>

                    </div>
                    <div class="col-4">
                      <button class="btn btn-success"
                              @click="prolongBook(book.id)"
                              v-if="book.reader_id != 0 && book.status_id != 1 && Date.now() > (new Date(book.updated_at)).setDate((new Date(book.updated_at)).getDate() + 1) && book.reader && book.library_id == $root.$data.libraryId"
                      >
                        Перевидати
                      </button>
                    </div>
                    <div class="col-4">
                        <button  v-if="book.reader && book.library_id == $root.$data.libraryId" class="btn btn-primary" @click="$root.setStatusBook($root.$data.searchresults.booksearched.id, $root.$data.searchresults.booksearched.reader_id, 1);$bvModal.hide('bookInfo')">
                            Повернути книгу
                        </button>
                    </div>
                </div>
            </template>
        </b-modal>
    </div>
</template>

<script>
    export default {
        name: "BookInfo",
        props:['book'],
        mounted() {
            //JsBarcode(".barcode").init(); // does not work
            this.$root.$on('bv::modal::hide', (bvEvent, modalId) => {
              if(modalId === 'bookInfo'){
                this.$root.$data.searchresults = {
                  reader: {
                    fullname: null,
                    address: null,
                    code: null,
                  },
                  booksearched: {
                    id: null,
                    code: null,
                    status_id: null,
                    description: {
                      title: null,
                      author: null,
                      publication: null
                    }
                  }
                }
              }
            })
        },
      methods:{
          prolongBook(id){
            axios.get('/library/prolong/'+id).then(()=>{
              this.$emit("back_book");
              this.$bvModal.hide('bookInfo');
              this.$root.searchInLibrary(this.book.code)
              this.$root.$refs.events.getStories(true);
            });
          },
          getModal(book){
            this.$bvModal.hide('bookInfo');
            if(this.$route.path === '/library' || this.$route.path === '/library/stories'){
              this.$root.searchInLibrary(this.book.reader.code)
            }
          },
          moment: function (date) {
            return moment(date);
          },
      }
    }

</script>

<style>
    .reader-content {
      border-radius: 16px;
    }
</style>

<style scoped>
    .avatar{
        width: 80px;
        height: 80px;
        background-size: cover;
        background-position: top center;
        border-radius: 50%;
        border: 3px solid #A7AFBA;
    }
    .cover{
        background-color: #F8F8F8;
        border-radius: 8px;
        width: 100%;
        height: 100%;
    }
    h1{
        font-size: 18px;
    }
    span{
        font-size: 13px;
    }
    .star-reader{
        color: #A7AFBA;
        font-size: 15px;
    }
    .star {
        color:#FFD384;
        font-size: 24px;
    }
    .btn-primary{
        height: 60px;
        width: 100%;
        border-radius: 8px;
    }
    .reader-avatar-show{
      font-size: 14px;
    }
    .reader-avatar-show span{
        font-size: 10px;
        color: #A7AFBA;
    }
    .reader-avatar-show .date{
        color: #414141;
    }
    .btn-debtor{
        width: 100%;
    }
</style>